import React, { FC, useState, useEffect } from 'react';
import { APIPrefix } from '../../../../constants/api.constants';
import { TSuggestionsProps } from '../../types/suggestions.types';

const Suggestions: FC<TSuggestionsProps> = ({ suggestionQuery, contextId, language, minimalLength, onUpdateQuery, className }) => {
  const [suggestions, setSuggestions] = useState([]);

  const updateSuggestions = (): void => {
    if (!suggestionQuery || suggestionQuery.length < minimalLength) {
      setSuggestions([]);
      return;
    }

    const suggestionApiUrl = `/${APIPrefix}/search-suggestions/get-suggestions?searchterm=${suggestionQuery}&contextId=${contextId}&language=${language}`;
    fetch(suggestionApiUrl)
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(`${res.status} : Failed to fetch search suggestions.`);
        }
      })
      .then((result) => {
        if (result?.length) {
          setSuggestions(result);
        } else {
          setSuggestions([]);
        }
      })
      .catch(() => {
        setSuggestions([]);
      });
  };

  useEffect(() => updateSuggestions(), [suggestionQuery]); // eslint-disable-line

  if (!suggestions) {
    return null;
  }

  return (
    suggestions && (
      <ul className={`search-suggestions ${className || ''}`}>
        {suggestions.map((suggestion) => (
          <li className="search-suggestions__item" key={suggestion}>
            {/* not a link with href */}
            <span role={'button'} className="search-suggestions__item__link" onClick={(): void => onUpdateQuery(suggestion)}>
              {suggestion}
            </span>
          </li>
        ))}
      </ul>
    )
  );
};

export default Suggestions;
